import { FilterToolbarClearAll } from "@components/common/faro-table/faro-table-filter/filter-toolbar-clear-all";
import { FilterToolbarQuickSearch } from "@components/common/faro-table/faro-table-filter/filter-toolbar-quick-search";
import { FilterToolbarTitle } from "@components/common/faro-table/faro-table-filter/filter-toolbar-title";
import { Stack } from "@mui/material";
import { useState } from "react";

interface Props {
  /** filter chips shown in filter toolbar */
  filterChipComponents: JSX.Element[];
}

/** Toolbar to show for filter chips in medium screens */
export function FilterToolbarMediumScreen({
  filterChipComponents,
}: Props): JSX.Element {
  const [shouldShowFilterChips, setShouldShowFilterChips] =
    useState<boolean>(false);

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack
          direction="row"
          justifyContent={"space-between"}
          sx={{
            height: "28px",
            alignItems: "center",
            gap: "8px",
            my: "17px",
          }}
        >
          <FilterToolbarTitle
            shouldShowFilterChips={shouldShowFilterChips}
            setShouldShowFilterChips={setShouldShowFilterChips}
          />
          <FilterToolbarClearAll />
        </Stack>
        <FilterToolbarQuickSearch />
      </Stack>

      {shouldShowFilterChips && (
        <Stack
          direction="row"
          justifyContent="flex-start"
          gap="2px"
          alignItems="center"
          flexWrap="wrap"
        >
          {filterChipComponents}
        </Stack>
      )}
    </>
  );
}
